import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import CreateSubscription from '../subscription/CreateSubscription';
import { getCookie } from '../../utils/cookie';
import { useFetchSubscriptionPlansQuery } from '../service';
import { getDefaultPlan } from '../utils';

const { Content } = Layout;

export default function FreeTrialSetupPage() {
    const [selectedPlanCode, setSelectedPlanCode] = useState<string | undefined>(() => getCookie('selectedPlan'));
    const { data: plans } = useFetchSubscriptionPlansQuery();

    useEffect(() => {
        if (plans && !selectedPlanCode) {
            setSelectedPlanCode(getDefaultPlan(plans)?.code);
        }
    }, [plans, selectedPlanCode]);

    return (
        <Content className="general-layout-content no-padding">
            <CreateSubscription
                className="free-trial-setup"
                selectedPlanCode={selectedPlanCode}
                title="7-Day Full Service Free Trial"
                buttonLabel="Start free trial"
                redirectTo="/user/account/setup"
                isInFreeTrialSetup
                onPlanCodeChange={setSelectedPlanCode}
            />
        </Content>
    );
}
